import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
 
export const fetchCForm = createAsyncThunk(
  "cForm/fetchCForm",
  async ({ year, month }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/BankReport/GetCForm?p_year=${year}&p_month=${month}`
      );
      if (response.data.StatusCode === 200) {
        return response.data.ResultSet || [];
      } else {
        return rejectWithValue("Failed to fetch C Form data");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  }
);


 
const initialState = {
  data: [],
  loading: false,
  error: null,
  selectedYear: new Date().getFullYear(),
  selectedMonth: new Date().getMonth() + 1,
  totalEmployer: 0,
  totalEmployee: 0,
  totalEarnings: 0,
  grandTotal: 0,
};
 
const cFormSlice = createSlice({
  name: "cForm",
  initialState,
  reducers: {
    setYear: (state, action) => {
      state.selectedYear = action.payload;
    },
    setMonth: (state, action) => {
      state.selectedMonth = action.payload;
    },
    clearData: (state) => {
      state.data = [];
      state.totalEmployer = 0;
      state.totalEmployee = 0;
      state.totalEarnings = 0;
      state.grandTotal = 0;
    },
    calculateTotals: (state) => {
      state.totalEmployer = state.data.reduce(
        (sum, item) => sum + parseFloat(item.Employer || 0),
        0
      );
      state.totalEmployee = state.data.reduce(
        (sum, item) => sum + parseFloat(item.Employee || 0),
        0
      );
      state.totalEarnings = state.data.reduce(
        (sum, item) => sum + parseFloat(item.TotalEarnings || 0),
        0
      );
      state.grandTotal = state.totalEmployer + state.totalEmployee;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
        state.totalEmployer = state.data.reduce(
          (sum, item) => sum + parseFloat(item.Employer || 0),
          0
        );
        state.totalEmployee = state.data.reduce(
          (sum, item) => sum + parseFloat(item.Employee || 0),
          0
        );
        state.totalEarnings = state.data.reduce(
          (sum, item) => sum + parseFloat(item.TotalEarnings || 0),
          0
        );
        state.grandTotal = state.totalEmployer + state.totalEmployee;
      })
      .addCase(fetchCForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch data";
      });
  },
});

export const { setYear, setMonth, clearData, calculateTotals } =
  cFormSlice.actions;

export default cFormSlice.reducer;